export default function filterDisabledQueues({ allQueues, disabledQueuePrefix }) {
  if (!disabledQueuePrefix) {
    return allQueues;
  }

  const prefix = new RegExp('^' + disabledQueuePrefix, 'i');

  return allQueues.filter((queue) => !prefix.test(queue.Name));
}
